import { render, staticRenderFns } from "./RunnitBaseSlider.vue?vue&type=template&id=bb46bcd4&scoped=true"
import script from "./RunnitBaseSlider.vue?vue&type=script&lang=ts"
export * from "./RunnitBaseSlider.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBaseSlider.vue?vue&type=style&index=0&id=bb46bcd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb46bcd4",
  null
  
)

export default component.exports